const GROUP_PRESENTATIONS = Object.freeze({
    pending: {label: "Ожидает оплаты", tone: "warning", known: true},
    partially_paid: {label: "Частично оплачен", tone: "warning", known: true},
    paid: {label: "Оплачен", tone: "success", known: true},
    cancelled: {label: "Отменен", tone: "neutral", known: true},
    expired: {label: "Истек", tone: "danger", known: true},
});

const PART_PRESENTATIONS = Object.freeze({
    pending: {label: "Ожидает", tone: "warning", known: true},
    paid: {label: "Оплачена", tone: "success", known: true},
    cancelled: {label: "Отменена", tone: "neutral", known: true},
    expired: {label: "Истекла", tone: "danger", known: true},
});

const UNKNOWN = Object.freeze({label: "Неизвестный статус", tone: "neutral", known: false});

export const getSplitGroupStatusPresentation = (status) =>
    GROUP_PRESENTATIONS[status] || UNKNOWN;

export const getSplitPartStatusPresentation = (status) =>
    PART_PRESENTATIONS[status] || UNKNOWN;

export const shouldPollSplit = (group) =>
    group?.status === "pending" || group?.status === "partially_paid";

export const canCancelSplit = (group, parts, hasAction) =>
    typeof hasAction === "function" &&
    hasAction("split_bills.cancel") &&
    group?.status === "pending" &&
    Array.isArray(parts) &&
    parts.length > 0 &&
    parts.every(({status}) => status === "pending");
